module.exports = __webpack_public_path__ + "img/down-arrow.c2f41f2e.svg";